var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisitpriceHead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#E7ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7503 18.6666H26.2503V16.4999H19.7503V18.6666ZM12.167 31.6666V26.2499H16.5003V27.3333H18.667V26.2499H27.3337V27.3333H29.5003V26.2499H33.8337V31.6666H12.167ZM12.167 25.1666V20.8333C12.167 20.2374 12.3793 19.7275 12.804 19.3036C13.2287 18.8796 13.7385 18.6673 14.3337 18.6666H17.5837V16.4999C17.5837 15.9041 17.796 15.3942 18.2207 14.9703C18.6453 14.5463 19.1552 14.334 19.7503 14.3333H26.2503C26.8462 14.3333 27.3564 14.5456 27.7811 14.9703C28.2057 15.3949 28.4177 15.9048 28.417 16.4999V18.6666H31.667C32.2628 18.6666 32.7731 18.8789 33.1977 19.3036C33.6224 19.7283 33.8344 20.2381 33.8337 20.8333V25.1666H29.5003V22.9999H27.3337V25.1666H18.667V22.9999H16.5003V25.1666H12.167Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitpriceHead);
export default __webpack_public_path__ + "static/media/visitprice-head.7e939425b60872e0964510f3c7a9639c.svg";
export { ForwardRef as ReactComponent };